export const USER_TYPE_OPTIONS = [
  { value: "CASHIER", label: "ra.users.userType.cashier" },
  { value: "ENTITY", label: "ra.users.userType.entity" },
  { value: "USER", label: "ra.users.userType.user" },
  { value: "ADMIN", label: "ra.users.userType.admin" },
] as const;

export type UserType = (typeof USER_TYPE_OPTIONS)[number]["value"];
export function getUserTypeLabel(value: UserType): string {
  return USER_TYPE_OPTIONS.find((t) => t.value === value)?.label || value;
}
